import React, { Component } from 'react';
import { database } from 'firebase';
import Table from '../Books/Table';
import Modal from '../Books/Modal';
import Loader from '../Books/Loader';

const booksRef = database().ref('/books');

class Keywords extends Component {
  constructor () {
    super();
    this.handleFilteredBooks = this.handleFilteredBooks.bind(this);
    this.handleEditBook = this.handleEditBook.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.booksRef = booksRef;
    this.state = {
      books: null,
      filteredBooks: null,
      modal: null
    };
  }

  handleFilteredBooks (paramsKeyword, cb) {
    let keyword = paramsKeyword;
    this.booksRef.on('value', (snap) => {
      let filteredBooks = [];
      snap.forEach(book => {
        if (book.val().Keywords && book.val().Keywords.indexOf(keyword) > -1) {
          let filteredBook = book.val();
          filteredBook.key = book.key;
          filteredBooks.push(filteredBook);
        }
      });

      if(cb) {
        cb(filteredBooks);
      }
    });
  }

  handleModal (book) {
    this.setState({
      modal: <Modal book={book}  user={this.props.user} closeModal={this.handleCloseModal} editBook={this.handleEditBook}/>
    })
  }

  handleEditBook (book) {
    const self = this;
    const key = book.key;
    delete book.key;
    this.booksRef.child(key).set(book).then(() => {
      console.log('Book with id ' + key + ' has been updated!');
      self.setState({
        modal: null
      })
    }).catch(err => {
      console.log(err);
    });
  }

  handleCloseModal (e) {
    e.preventDefault();
    this.setState({
      modal: null
    });
  }

  componentWillMount () {
    let keyword = this.props.params.keyword;
    this.handleFilteredBooks(keyword, filteredBooks => {

      this.setState({
        filteredBooks
      });

    });
  }

  componentWillReceiveProps(newProps) {
    let keyword = newProps.params.keyword;
    this.handleFilteredBooks(keyword, filteredBooks => {
      if (filteredBooks) {
        this.setState({
          filteredBooks
        });
      }
    });
  }

  componentWillUnmount () {
    this.booksRef.off();
  }

  render () {
    let books = this.state.filteredBooks && this.state.filteredBooks.length > 0 ? (
      <div>
        <h2>Database Results - <span className="badge">{this.state.filteredBooks.length}</span></h2>
        {this.state.modal ? this.state.modal : null}
        <Table books={this.state.filteredBooks} handleModal={this.handleModal}/>
      </div>
    ) : (
      <div>
        <h2>Database Results - <span className="badge">0</span></h2>
        <h4>No books were found for Keyword {this.props.params.keyword}</h4>
      </div>
    )
    return (
      <div>
        <h2>Keyword - {this.props.params.keyword}</h2>
        { this.state.filteredBooks ? (
          books
        ) : (
          <Loader />
        ) }
      </div>
    );

  }
}

export default Keywords;



/** WEBPACK FOOTER **
 ** ./src/components/Pages/Keyword.js
 **/